// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';

import store from './store'

import routerUtil from './utils/routerutil'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Dialog } from 'vant';
import Print from 'vue-print-nb'
import Plugin from 'v-fit-columns';
import { has, nothas } from './utils/helper/btnPermissions'

import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import './css/global.css'

Vue.use(Plugin);
Vue.use(Print)

// 全局注册
Vue.use(Dialog);

routerUtil(router)
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(has)
Vue.use(nothas)

Vue.prototype.$FileSaver = FileSaver;
Vue.prototype.$XLSX = XLSX;



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,

  components: { App },
  template: '<App/>',
  mounted() {
    // const type = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) ? 2 : 1
    // if (
    //   !JSON.parse(sessionStorage.getItem('userName')) ||
    //   (JSON.parse(sessionStorage.getItem('userName')) && !JSON.parse(sessionStorage.getItem('userName')).UserName)
    // ) {
    //   this.$router.push({
    //     path: type === 1 ? '/pc_login' : '/m_login'
    //   })
    // }
    if (
      !JSON.parse(sessionStorage.getItem('userName')) ||
      (JSON.parse(sessionStorage.getItem('userName')) && !JSON.parse(sessionStorage.getItem('userName')).UserName)
    ) {
      this.$router.push({
        path: '/pc_login'
      })
    }
    if (
      JSON.parse(sessionStorage.getItem('Actions')) ||
      (JSON.parse(sessionStorage.getItem('Actions')) && JSON.parse(sessionStorage.getItem('Actions'))[0].ActionID)
    ) {
      this.$store.dispatch('GetInfo').then(res => {
        this.$store.dispatch('GenerateRoutes').then(() => {
          router.addRoutes(store.getters.addRouters)
        })
      })
    }
  },
})



// WEBPACK FOOTER //
// ./src/main.js